/**
 * Created by Administrador on 11/04/2016.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('modelAirService', modelAirService);

    modelAirService.$inject = ['$http', 'CONFIG', 'messageService'];

    function modelAirService($http, CONFIG, messageService){
        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_FLIGHT_CONTROL + '/' + CONFIG.API ;
        var service = {
            updateModelSsr: updateModelSsr,
            getRouteItinerariesRevenuePlan2: getRouteItinerariesRevenuePlan2,
            findModelAircraftSsr: findModelAircraftSsr
        };

        return service;

        function updateModelSsr(segmentItineraries){
            return $http.put(urlBase + "/modelAircrafts/ssr/plan" , segmentItineraries)
                .then(function(response){
                    messageService.registerUpdate('');
                    return "ok";
                })
                .catch(function(error){
                    messageService.registerUpdateError('');
                    return "error";
                });
        }

        function getRouteItinerariesRevenuePlan2(itineraryId,makerId_modelId,page, size) {
            var url = '/routeItineraries/revenue/plans/1?page=' + page + '&size=' + size;
            if (makerId_modelId !== "") {
                url = url + '&makerId_modelId=' + makerId_modelId;
            }
            return $http.get(urlBase+ url).then(getComplete).catch(getFailed);

            function getComplete(response){
                return response;
            }
            function getFailed(){
                messageService.findAllError('');
            }
        }

        function findModelAircraftSsr(makerId_modelId, page, size) {
            var url = '/modelAircrafts/ssr/' + makerId_modelId + '?page=' + page + '&size=' + size;
            if (makerId_modelId === '') {
                url = '/modelAircrafts/ssr/0_0?page=' + page + '&size=' + size;
            }
            return $http.get(urlBase + url).then(getComplete).catch(getFailed);
            function getComplete(response){
                return response;
            }
            function getFailed(){
                messageService.findAllError('');
            }
        }
    }
})();

